import * as actionType from "../actions/actionType";

const initialState = {
  tableList: [],
  page: 1,
  pageSize: 10,
  loading: false,
  level: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.MINE_UPDATE_STATE:
      return {
        ...state,
        ...action.payload.obj,
      };
    case actionType.MINE_RESET_STATE:
      return {
        tableList: state.tableList,
        page: 1,
        pageSize: state.pageSize,
        loading: false,
        level: "",
      };

    default:
      return state;
  }
};
